(function() { window.GUID_4a5dd5d1_1c8b_420c_ab3f_07e08f268057 = { getGuid: function() { return "4a5dd5d1-1c8b-420c-ab3f-07e08f268057"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-statgraph",
                        callback: (accordion, e) => {
                            const $shouldHideHiddenInput = accordion.$Container.find(`.ShouldHideWallSection`);
                            if ($shouldHideHiddenInput.length) {
                                const shouldHide = $shouldHideHiddenInput.val() == "true";
                                if (shouldHide) {
                                    accordion.$Container.hide();
                                }
                            }
                            accordion.beforeCollapseCallback = () => {
                                return new Promise((resolve, reject) => {
                                    try {
                                        const $innerBarChartAccordions = accordion.$Container.find(".accordion-barchart");
                                        if (!$innerBarChartAccordions.length) {
                                            return resolve();
                                        }
                                        for (let i = 0; i < $innerBarChartAccordions.length; i++) {
                                            const innerAccordion = CS.Controls.GetInstance(CS.Controls.Accordion, $($innerBarChartAccordions[i]), true);
                                            if (innerAccordion == null) {
                                                return resolve();
                                            }
                                            if (innerAccordion.CustomData.scrollableBarChart == null) {
                                                return resolve();
                                            }
                                            innerAccordion.CustomData.scrollableBarChart
                                                .destroy()
                                                .then(() => {
                                                return resolve();
                                            })
                                                .catch((error) => {
                                                return reject(error);
                                            });
                                        }
                                    }
                                    catch (error) {
                                        return reject(error);
                                    }
                                });
                            };
                        },
                    });
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-linegraph",
                        callback: (accordion, e) => {
                            if (accordion.IsExpanded) {
                                const $shouldHideHiddenInput = accordion.$Container.find(`.ShouldHideWallSection`);
                                if ($shouldHideHiddenInput.length) {
                                    const shouldHide = $shouldHideHiddenInput.val() == "true";
                                    if (shouldHide) {
                                        accordion.$Container.hide();
                                    }
                                }
                                const $statUserGraphsInputs = accordion.$Container.find(`.LineGraphSectionViewModelStatUserGraphs-${accordion.ContentId}`);
                                if ($statUserGraphsInputs.length) {
                                    try {
                                        const data = [];
                                        $statUserGraphsInputs.each((index, input) => {
                                            const $input = $(input);
                                            const val = $input.val();
                                            const parsedVal = JSON.parse(val);
                                            const isArray = Array.isArray(parsedVal);
                                            if (isArray) {
                                                data.push(...parsedVal);
                                            }
                                        });
                                        if (data.length) {
                                            const rootId = `${accordion.ContentId}-chart-root`;
                                            const chartContainerHTML = `
                <div id="${rootId}" class="">
                </div>
                `;
                                            const statFieldIds = data
                                                .map((d) => { var _a; return (_a = d.StatFieldId) !== null && _a !== void 0 ? _a : ""; })
                                                .filter((id) => id != null);
                                            const distinctStatFieldIds = statFieldIds.filter((id, index) => statFieldIds.indexOf(id) === index);
                                            let overrideValueFormatter = undefined;
                                            let overrideMin = undefined;
                                            let overrideMax = undefined;
                                            if (distinctStatFieldIds.length === 1) {
                                                if (distinctStatFieldIds[0] === "WinPercent") {
                                                    overrideValueFormatter = (value) => {
                                                        return `${value}%`;
                                                    };
                                                    overrideMin = 0;
                                                    overrideMax = 100;
                                                }
                                            }
                                            const $chartContainer = accordion.$Container.find(`#${rootId}`);
                                            if ($chartContainer.length) {
                                                $chartContainer.remove();
                                            }
                                            accordion.$Container.prepend(chartContainerHTML);
                                            const lineChart = new CS.Controls.LineChart(rootId, data, overrideValueFormatter, overrideMin, overrideMax);
                                            lineChart.init();
                                        }
                                    }
                                    catch (error) {
                                        console.error("Error while parsing stat user graphs", error);
                                    }
                                }
                                const $elementsToRemove = accordion.$Container.find(".linegraph-section__header, .linegraph-section__body");
                                if ($elementsToRemove.length) {
                                    $elementsToRemove.remove();
                                }
                            }
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.js.map
